import React from 'react';
import {
  DomainCardGroup,
  DomainCardReceiptPreferences,
  getCardGroupLabelKey,
} from 'routes/profile/models/ReceiptSettings';
import CardInstanceRow from './CardInstanceRow';
import { useTranslation } from 'react-i18next';

type CardGroupAccordionProps = {
  cardGroup: DomainCardGroup;
  preferences: DomainCardReceiptPreferences[];
  isToggleDisabled: boolean;
};

const CardGroupAccordion: React.FC<CardGroupAccordionProps> = ({
  cardGroup,
  preferences,
  isToggleDisabled,
}) => {
  const { t } = useTranslation();
  const groupLabelKey = getCardGroupLabelKey(cardGroup.type);
  const groupLabel = groupLabelKey ? t(groupLabelKey) : null;

  return (
    <div className="mt-4">
      {groupLabel && <p className="text-sm text-gray-400 mb-2">{groupLabel}</p>}
      {cardGroup.instances.map((instance) => (
        <CardInstanceRow
          key={`${instance.id}-${instance.panSequenceNumber}`}
          instance={instance}
          isToggleDisabled={isToggleDisabled}
          preferences={preferences}
        />
      ))}
    </div>
  );
};

export default CardGroupAccordion;
